/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AvailablePowerSource } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class DeviceService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get manufacturer name
   *
   * LWM2M path: /3//0
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getManufacturer(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getManufacturerCall());
  }

  /**
   *
   *
   * LWM2M path: /3//0
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getManufacturerCall(): ServiceCallType {
    const callOptions = { ...this.resources.getManufacturer };

    return callOptions;
  }

  /**
   * Get device firmware flavor name
   *
   * LWM2M path: /3//1
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getFirmwareFlavor(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getFirmwareFlavorCall());
  }

  /**
   *
   *
   * LWM2M path: /3//1
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getFirmwareFlavorCall(): ServiceCallType {
    const callOptions = { ...this.resources.getFirmwareFlavor };

    return callOptions;
  }

  /**
   * Get device serial number
   *
   * LWM2M path: /3//2
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getSerialNumber(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getSerialNumberCall());
  }

  /**
   *
   *
   * LWM2M path: /3//2
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getSerialNumberCall(): ServiceCallType {
    const callOptions = { ...this.resources.getSerialNumber };

    return callOptions;
  }

  /**
   * Get device firmware version
   *
   * LWM2M path: /3//3
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getFirmwareVersion(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getFirmwareVersionCall());
  }

  /**
   *
   *
   * LWM2M path: /3//3
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getFirmwareVersionCall(): ServiceCallType {
    const callOptions = { ...this.resources.getFirmwareVersion };

    return callOptions;
  }

  /**
   * Reboot Tap device
   *
   * LWM2M path: /3//4
   *
   * @tapVersion(">=1.0")
   * @return
   */
  reboot(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.rebootCall());
  }

  /**
   *
   *
   * LWM2M path: /3//4
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  rebootCall(): ServiceCallType {
    const callOptions = { ...this.resources.reboot };

    return callOptions;
  }

  /**
   * Factory reset
   *
   * LWM2M path: /3//5
   *
   * @tapVersion(">=1.0")
   * @return
   */
  factoryReset(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.factoryResetCall());
  }

  /**
   *
   *
   * LWM2M path: /3//5
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  factoryResetCall(): ServiceCallType {
    const callOptions = { ...this.resources.factoryReset };

    return callOptions;
  }

  /**
   * Get available power sources
   *
   * LWM2M path: /3//6
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAvailablePowerSource(): Promise<TapResponse<AvailablePowerSource>> {
    return this.serviceCallRunner.execute(this.getAvailablePowerSourceCall());
  }

  /**
   *
   *
   * LWM2M path: /3//6
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAvailablePowerSourceCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAvailablePowerSource };

    return callOptions;
  }

  /**
   * Get power source voltage
   *
   * LWM2M path: /3//7
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPowerSourceVoltage(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getPowerSourceVoltageCall());
  }

  /**
   *
   *
   * LWM2M path: /3//7
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPowerSourceVoltageCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPowerSourceVoltage };

    return callOptions;
  }

  /**
   * Get device memory free
   *
   * LWM2M path: /3//10
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMemoryFree(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getMemoryFreeCall());
  }

  /**
   *
   *
   * LWM2M path: /3//10
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMemoryFreeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMemoryFree };

    return callOptions;
  }

  /**
   * Get device last error code
   *
   * LWM2M path: /3//11
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getLastErrorCode(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getLastErrorCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /3//11
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getLastErrorCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getLastErrorCode };

    return callOptions;
  }

  /**
   * Set device last error code
   *
   * LWM2M path: /3//11
   *
   * @tapVersion(">=1.0")
   * @param errorcode input
   * @return
   */
  postLastErrorCode(
    /*
     *
     */
    errorcode: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.postLastErrorCodeCall(errorcode),
    );
  }

  /**
   *
   *
   * LWM2M path: /3//11
   *
   * @tapVersion(">=1.0")
   * @param errorcode input
   * @return call options
   */
  postLastErrorCodeCall(
    /*
     *
     */
    errorcode: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postLastErrorCode };

    callOptions.body = errorcode;

    return callOptions;
  }

  /**
   * Reset device last error code
   *
   * LWM2M path: /3//12
   *
   * @tapVersion(">=1.0")
   * @return
   */
  resetLastErrorCode(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.resetLastErrorCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /3//12
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  resetLastErrorCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.resetLastErrorCode };

    return callOptions;
  }

  /**
   * Get device current time
   *
   * LWM2M path: /3//13
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getCurrentTime(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getCurrentTimeCall());
  }

  /**
   *
   *
   * LWM2M path: /3//13
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getCurrentTimeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCurrentTime };

    return callOptions;
  }

  /**
   * Set device current time
   *
   * LWM2M path: /3//13
   *
   * @tapVersion(">=1.0")
   * @param time input
   * @return
   */
  putCurrentTime(
    /*
     *
     */
    time: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putCurrentTimeCall(time));
  }

  /**
   *
   *
   * LWM2M path: /3//13
   *
   * @tapVersion(">=1.0")
   * @param time input
   * @return call options
   */
  putCurrentTimeCall(
    /*
     *
     */
    time: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCurrentTime };

    callOptions.body = time;

    return callOptions;
  }

  /**
   * Get device internal status
   *
   * LWM2M path: /3//15
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getInternalStatus(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getInternalStatusCall());
  }

  /**
   *
   *
   * LWM2M path: /3//15
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getInternalStatusCall(): ServiceCallType {
    const callOptions = { ...this.resources.getInternalStatus };

    return callOptions;
  }
}
